import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ButtonContainer, NavContainer } from './StyledComponents';

export default class Navbar extends Component {
  render() {
    return (
      <NavContainer>
        <Link to="/" id='homeButton'>
          <p>Home</p>
        </Link>
        <Link to="/" id='productsButton'>
          <p>Products</p>
        </Link>
        <Link to="/cart" id='cartButton'>
          <ButtonContainer>Cart</ButtonContainer>
        </Link>
      </NavContainer>
    );
  }
}